const ApiAttributesKeys = {
  chapterIdKey: 'chapter_id',
  chapterNameKey: 'chapter_name',
  videoTableKey: 'cfa1_2025_videos',
  videoTitleKey: 'title',
  youtubeIdKey: 'url_id',
  videoTableNameKey: 'cfa1_2025_videos',
  videoTableChapterIdKey: 'chapter_id',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Videos/PlayList/ApiAttributesKays.js